import { addStyles } from 'ethcss'
import { colors, grid, IStyles, item, mediaCSS, textSizes } from '../../theme'
import { radiusSizes } from 'blocks.app/config'

const reportStyles: IStyles = {
    reportType: {
        ...grid.pb_md,
        ...grid.pt_md,
        ...grid.w35,
        margin: '0 auto',
    },
    tabs: {
        ...grid.row,
        borderRadius: radiusSizes.mini,
    },
    reportWrapper: {
        ...grid.hspace,
        ...item.white,
        borderRadius: radiusSizes.mini,
    },
    typeAndView: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0 41px',

        [mediaCSS.mini]: {
            padding: '0 20px',
        },
    },
    paddingMobile: {
        [mediaCSS.mini]: {
            padding: '0 20px',
        },
    },
    title: {
        ...grid.pl_big,
        ...grid.pr_big,
        ...grid.pt_md,
        ...grid.pb_md,
        ...item.white,
    },
    advTitle: {
        ...grid.pb_md,
        ...grid.pl_md,
        fontSize: textSizes.md,
        ...item.white,
    },
    listWrapper: {
        ...grid.p_md,
        ...grid.mb_micro,
        ...grid.col,
        ...item.white,
    },
    whiteBlock: {
        ...grid.p_md,
        ...grid.pb_none,
        ...grid.mt_micro,
        ...item.white,
        ...item.rounded_bottom_mini,
    },
    radio: {
        ...grid.mr_md,
        ...grid.mb_mini,
    },
    report__catalog: {
        ...grid.hspace,
        ...grid.pl_big,
        ...grid.pr_big,
        ...grid.pb_big,
        [mediaCSS.tab]: {
            ...grid.p_mini,
        },
    },
    reportsWrapper: {
        [mediaCSS.tab]: {
            paddingTop: 60,
        },
    },
    subStepsWrapper: {
        marginTop: 36,
    },
    subSteps: {
        display: 'flex',
        padding: '0 41px',

        [mediaCSS.tab]: {
            padding: '0 20px',
            flexWrap: 'wrap',
            gap: 12,
            justifyContent: 'center',
        },
    },
    subStep: {
        padding: '12px 60px',
        borderRadius: 8,
        border: `1px solid ${colors.blueWhite}`,
        marginRight: 20,
        transition: 'all 0.3s',
        cursor: 'pointer',

        '&:hover': {
            backgroundColor: colors.blueAccent,
            color: colors.white,
            borderColor: 'transparent',
        },
    },
    subStepSelected: {
        backgroundColor: colors.blueAccent,
        color: colors.white,
        borderColor: 'transparent',
    },
    subStepsTitle: {
        marginBottom: 20,
        padding: '0 41px',

        [mediaCSS.tab]: {
            padding: '0 20px',
        },
    },
    dropdownWrapper: {
        width: '25%',
        [mediaCSS.tab]: {
            width: '100%',
            marginBottom: 12,
        },
    },
    disabled: {
        opacity: 0.5,
        pointerEvents: 'none',
    },
}

addStyles(reportStyles)
export default reportStyles
